<template>
  <div
    class="block-text"
    tabindex="0"
  >
    <div class="info-row">
      <div class="info-row-label">
        <p>
          {{ label }}
        </p>
        <slot />
      </div>
      <div class="info-row-value">
        <p>
          <strong>{{ value }}</strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BlockText',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
};

</script>

<style lang="scss" src="@/components/block-text/block-text.scss">
</style>